import React from 'react'
import { classNames } from '~/utils/client/helpers'

interface CardProps {
  children: React.ReactNode
  className?: string
  variant?: 'default' | 'highlighted'
}

const Card: React.FC<CardProps> = ({ children, className = '', variant = 'default' }) => {
  const baseClasses = 'rounded-lg'

  const variantClasses = {
    default: 'bg-white/50',
    highlighted: 'bg-white',
  }

  return (
    <div className={classNames(baseClasses, variantClasses[variant], className)}>{children}</div>
  )
}

export default Card
